<template>
  <div class="data-query">
    <OtherQuery :otherQueryParams="otherQueryParams"/>
    <SelectData
        :dimensionCheckList="dimensionCheckList"
        :conditionCheckList="conditionCheckList"
        :fieldsCheckList="fieldsCheckList"
        :fieldsList="fieldsList"
        :dimensionList="dimensionList"
    />
  </div>
</template>

<script>
import OtherQuery from './otherQuery.vue'
import SelectData from './selectData.vue'
export default {
    name: "DataQuery",
    components: { OtherQuery, SelectData },
    props: {
        dimensionCheckList: {
            type: Array,
            default: ()=>[]
        },
        fieldsCheckList: {
            type: Array,
            default: ()=>[]
        },
        conditionCheckList: {
            type: Array,
            default: ()=>[]
        },
        fieldsList: {
            type: Array,
            default: ()=>[]
        },
        dimensionList: {
            type: Array,
            default: ()=>[]
        },
        otherQueryParams: {
            type: Object,
            default: ()=>({})
        }
    }
}
</script>

<style lang="scss" scoped>
.data-query {
    border: 1px solid #ccc;
    padding: 2px 10px;
    height: 200px;
    background-color: #fff;
}
</style>